import { apiService } from "@/core/api";
import { API_ENDPOINTS } from "@/core/constants/endpoints";
import { TermsApiResponse, VocabularyType } from "./types";

class TermsService {
  async getTermsByVocId(vocId: VocabularyType): Promise<TermsApiResponse> {
    const endpoint = API_ENDPOINTS.GLOBAL.TERM.replace("{voc_id}", vocId);
    return await apiService.get<TermsApiResponse>(endpoint);
  }

  async getAllTerms(): Promise<{ [K in VocabularyType]: TermsApiResponse }> {
    const vocabularies: VocabularyType[] = [
      "countries",
      "expenditure",
      "expertise",
      "funding_range",
      "funding_type",
      "looking_for",
      "notification_type",
      "organization_categories",
      "organization_employees_number",
      "organization_turnover",
      "programme",
      "sectors",
      "tags",
    ];

    const results = await Promise.allSettled(
      vocabularies.map(async (vocId) => ({
        vocId,
        data: await this.getTermsByVocId(vocId),
      })),
    );

    const termsData = {} as { [K in VocabularyType]: TermsApiResponse };

    results.forEach((result, index) => {
      const vocId = vocabularies[index];
      if (result.status === "fulfilled") {
        termsData[vocId] = result.value.data;
      } else {
        console.error(`Failed to fetch terms for ${vocId}:`, result.reason);
        termsData[vocId] = { data: [] };
      }
    });

    return termsData;
  }
}

export const termsService = new TermsService();
